<template>
  <div id="surveys">
    <Navbar current="Pesquisas" />
    <Sidebar />
    <Container col="col-12">
      <Header
        :isSubHeader="false"
        title="Pesquisas"
        subtitle="Enquetes enviadas por e-mail para psicólogos e pacientes"
        :iconClass="'fa-solid fa-square-poll-vertical text-primary'"
        :totalCount="total"
      >
        <template v-slot:button>
          <router-link :to="$paths.surveys.add" class="btn btn-primary">
            <i class="fa-solid fa-plus me-1"></i> Nova pesquisa
          </router-link>
        </template>
      </Header>

      <div class="d-flex gap-2 mb-3">
        <select
          class="form-select form-select-sm"
          style="max-width: 220px"
          v-model="statusFilter"
          @change="applyFilter"
        >
          <option value="">Todos os status</option>
          <option value="draft">Rascunho</option>
          <option value="sending">Enviando</option>
          <option value="sent">Enviada</option>
          <option value="closed">Encerrada</option>
        </select>
      </div>

      <div class="card">
        <LoadingContainer v-if="loading" />
        <EmptyState
          v-else-if="!items.length"
          :title="'Nenhuma pesquisa'"
          :msg="'Crie a primeira pesquisa clicando em Nova pesquisa.'"
        />
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Título</th>
                <th>Status</th>
                <th class="text-end">Destinatários</th>
                <th class="text-end">Respostas</th>
                <th>Enviada em</th>
                <th>Criada em</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in items"
                :key="item.uuid"
                class="cursor-pointer"
                @click="$router.push(`${$paths.surveys.detail}/${item.uuid}`)"
              >
                <td>{{ item.title }}</td>
                <td>
                  <span class="badge" :class="statusClass(item.status)">
                    {{ statusLabel(item.status) }}
                  </span>
                </td>
                <td class="text-end">{{ item.recipients }}</td>
                <td class="text-end">{{ item.answered }}</td>
                <td>{{ formatDate(item.sent_at) }}</td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td class="text-end">
                  <router-link
                    :to="`${$paths.surveys.detail}/${item.uuid}`"
                    class="btn btn-sm btn-white"
                    @click.native.stop
                  >
                    <span class="fe fe-arrow-up-right"></span>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="card-footer d-flex justify-content-between align-items-center"
          v-if="!loading && lastPage > 1"
        >
          <span class="text-muted small">
            Mostrando {{ items.length }} de {{ total }} pesquisas
          </span>
          <div class="d-flex gap-2">
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="currentPage <= 1"
              @click="changePage(currentPage - 1)"
            >
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <span class="align-self-center small">
              Página {{ currentPage }} de {{ lastPage }}
            </span>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="currentPage >= lastPage"
              @click="changePage(currentPage + 1)"
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import SurveyListController from "./SurveyListController";
export default SurveyListController;
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
